import React from 'react';
import 'twin.macro';
import _orderBy from 'lodash-es/orderBy';
import { format } from 'utils/time/format';
import { getDurationInHoursAndMinutes } from '@teetsh/app/src/utils/time/getDurationInHoursAndMinutes';

export interface Element {
  id: string;
  name: string;
  start: Date;
  lasting: number;
}

interface Props {
  elements: Element[];
}

export function Details(props: Props) {
  const { elements } = props;
  return (
    <div tw="pt-4 pb-3 px-4 space-y-2 -mt-3">
      {_orderBy(elements || [], ['start'], ['asc']).map(e => (
        <div
          key={e.id}
          tw="flex justify-between items-center text-sm text-neutral-quiet pr-5"
        >
          <div tw="flex-1 truncate">{e.name}</div>
          <div tw="flex items-center gap-8">
            {e.start && (
              <span tw="capitalize">
                {format(e.start, 'fr-FR', "eee HH'h'mm").replace('.', '')}
              </span>
            )}
            <span tw="min-w-[3rem] text-right">
              {getDurationInHoursAndMinutes(e.lasting, {
                short: true,
                noMinuteSuffixWhenHours: true,
              })}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
}
